import { useContext } from 'react'
import { ThreadsListContextData } from '../types/ThreadsListContextData'
import { ThreadsListContext } from './threadsList'

export const useThreadsList = () => useContext<ThreadsListContextData>(ThreadsListContext)
